import { COMPONENT_CATALOG } from '@calculom/report-designer';
import { PaletteTile } from './PaletteTile';

interface ComponentPaletteProps {
  width?: number;
}

export function ComponentPalette({ width }: ComponentPaletteProps) {
  const layoutItems = COMPONENT_CATALOG.filter((c) => c.category === 'layout');
  const dataItems = COMPONENT_CATALOG.filter((c) => c.category === 'data');

  return (
    <aside
      className="bg-gray-50 border-r border-gray-200 p-4 overflow-y-auto flex-shrink-0"
      style={width ? { width } : { width: 224 }}
    >
      <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
        Row Components
      </h2>

      <div className="mb-4">
        <h3 className="text-xs font-medium text-gray-400 uppercase mb-2">Layout</h3>
        <div className="space-y-2">
          {layoutItems.map((item) => (
            <PaletteTile key={item.id} item={item} />
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-medium text-gray-400 uppercase mb-2">Data</h3>
        <div className="space-y-2">
          {dataItems.map((item) => (
            <PaletteTile key={item.id} item={item} />
          ))}
        </div>
      </div>
    </aside>
  );
}
